import { useDispatch, useSelector } from "react-redux";
import ButtonBig from "../../../shared/components/button_big";
import { RoutesWeb } from "../../../shared/interfaces/routes";
import { mainSlice, selectMainState } from "../../../stateManagement/redux";
import { DepartmentNameEnum } from "../../../stateManagement/redux/slices/shared/interfaces";

export const GerenciaTecnicaOptions = (props: { onClick: any }) => {
    const mainState = useSelector(selectMainState);

    const dispatch: any = useDispatch();

    const onClick = () => {
        dispatch(mainSlice.actions.setShowMenu());
    };

    const onClickMenu = (path: string) => {
        if (
            !mainState.activeDepartment ||
            mainState?.activeDepartment?.id !== DepartmentNameEnum.wellWhisper
        ) {
            localStorage.setItem(
                "activeDepartmentId",
                DepartmentNameEnum.wellWhisper
            );
            dispatch(mainSlice.actions.setShowMenu());
        }
        props.onClick(path);
    };

    return (
        <div className="wrap-main__menu">
            <div className="wrap-main__menu__container_header">
                <img
                    src="/assets/icons/well_whisper.svg"
                    alt="Well Whisper"
                    height={40}
                    width={40}
                />
                <div>Well Whisper</div>
                <div
                    className="wrap-main__menu__close_icon"
                    onClick={() => onClick()}
                >
                    <img
                        src="/assets/icons/arrow-left.svg"
                        alt="Well Whisper"
                        height={8}
                        width={8}
                    />
                </div>
            </div>
            <div className="wrap-main__menu__container_buttons">
                <ButtonBig
                    text="Dashboard"
                    onClick={() => onClickMenu("/gto/dashboard/0")}
                />
                {/* <ButtonBig text='Ali' onClick={() => onClickMenu('/well-whisper/ali')} /> */}
                <ButtonBig
                    text="Historial Actividades"
                    onClick={() =>
                        onClickMenu(
                            RoutesWeb.gerencia_tecnica_operaciones.history
                        )
                    }
                />
                <ButtonBig
                    text="Subidas de Archivos"
                    onClick={() =>
                        onClickMenu(
                            RoutesWeb.gerencia_tecnica_operaciones.upload
                        )
                    }
                />
            </div>
        </div>
    );
};
